import React from "react";
import ResourceState from "../resourceState/ResourceState";
import Pager from "../pager/Pager";
import { getConsultationStatus } from "../CallLeadDetails.utils";

const Consultations = ({ resource, formatDate, onPage }) => (
  <ResourceState resource={resource} emptyText="No consultations found.">
    <div className="cw-table-wrap" tabIndex="0" aria-label="Consultations">
      <table className="cw-table cw-history-table">
        <thead><tr><th>Consultation</th><th>Date</th><th>Doctor</th><th>Mode</th><th>Status</th></tr></thead>
        <tbody>
          {resource.data.data.map((item) => (
            <tr key={item.id}>
              <td>#{item.consultation_id || item.id}</td>
              <td>{formatDate(item.start_time || item.created_at, true)}</td>
              <td>{item.doctor ? item.doctor.name : "—"}</td>
              <td>{item.consultation_mode || item.call_type || "—"}</td>
              <td>{getConsultationStatus(item)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <Pager page={resource.data} loading={resource.loading} onPage={onPage} />
  </ResourceState>
);

export default Consultations;
